import * as React from 'react';
import { doc, onSnapshot } from 'firebase/firestore';

import { firebaseFirestore } from 'services/firebase/authentication';

// Definindo interfaces necessárias
interface OptionsHook {
  options: IOptions | undefined;
  pendingOptions: boolean;
}

interface IOptions {
  id: string;
  count: number;
}

// Hook personalizado para obter a contagem de blogs.
// Retorna um objeto contendo o número de blogs e um booleano indicando se o carregamento padrão está em andamento.
export function useSearchOptions(): OptionsHook {
  // Definindo estados iniciais
  const [options, setOptions] = React.useState<IOptions>();
  const [pendingOptions, setPendingOptions] = React.useState(false);

  // Hook personalizado para obter o número de blogs no Firestore.
  React.useEffect(() => {
    setPendingOptions(true);

    const unsubscribe = onSnapshot(
      doc(firebaseFirestore, 'ALL-code3c', '010500005', 'BWS-shard', 'posts'),
      (snapshot) => {
        if (snapshot.exists()) {
          const newUser = snapshot.data() as IOptions;
          setOptions({ ...newUser, id: snapshot.id });
          setPendingOptions(false);
        }
        setPendingOptions(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return { options, pendingOptions };
}
